<template>
      <v-row justify="center">
        <v-col cols="12" lg="10" class="admin-container">
      <!-- API Integrations Card -->
      <v-card class="mb-6 settings-card" elevation="2">
        <v-card-title class="primary-header">
          <v-icon class="ml-2" dark>mdi-api</v-icon>
          ניהול API ו-Webhooks
        </v-card-title>
        
        <v-card-text style="margin-top: 15px;">
          <!-- Search and Actions Bar -->
          <div class="d-flex flex-wrap justify-space-between align-center mb-4">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="חיפוש"
              outlined
              dense
              hide-details="auto"
              class="search-field"
              clearable
            ></v-text-field>
            
            <v-btn
              color="primary"
              class="refresh-button mt-0 mt-sm-0"
              @click="refreshDetails"
            >
              <v-icon left>mdi-refresh</v-icon>
              רענן
            </v-btn>
          </div>
          
          <!-- API Integrations Table -->
          <v-data-table
            :headers="headers"
            :items="dataFormated"
            :search="search"
            :footer-props="{ 
              'items-per-page-options': [10, 25, 50, 100, 200], 
              'items-per-page-text': 'שורות בעמוד:' 
            }"
            :loading="progressShow"
            loading-text="טוען נתונים..."
            no-data-text="אין נתוני API להצגה"
            class="api-table elevation-1"
          >
            <!-- Custom Header -->
            <template v-for="header in headers" v-slot:[`header.${header.value}`]="{ header }">
              <span class="table-header-text">{{ header.text }}</span>
            </template>
            
            <!-- Status Column -->
            <template v-slot:item.mode="{ item }">
              <v-chip
                :color="item.mode === 'פעיל' ? 'success' : 'error'"
                text-color="white"
                small
                class="status-chip"
              >
                {{ item.mode }}
              </v-chip>
            </template>
            
            <!-- URL Column -->
            <template v-slot:item.url="{ item }">
              <v-chip
                :color="item.url === 'קיים' ? 'info' : 'warning'"
                text-color="white"
                small
                class="url-chip"
              >
                {{ item.url }}
              </v-chip>
            </template>
            
            <!-- Actions Column -->
            <template v-slot:item.actions="{ item, index }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    @click="openEditDialog(item, index)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>עריכה</span>
              </v-tooltip>
            </template>
            
            <!-- Loading State -->
            <template v-slot:progress>
              <v-progress-linear
                color="primary"
                indeterminate
                absolute
                height="4"
              ></v-progress-linear>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      
      <!-- Loading Overlay -->
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
      </v-overlay>
      
      <!-- Edit Dialog -->
      <EditDialog 
        v-model="editDialog" 
        v-if="editDialog" 
        :itemToEdit="apiToEdit" 
        @apiEdited="editedApiSaved" 
      />
      
      <!-- Notification -->
      <SnackBar 
        v-model="snackbar" 
        :snacbarText="snacbarText" 
        :snackbarColorBt="snackbarColorBt"
      ></SnackBar>
        </v-col>
      </v-row>
  </template>
      
  <script>
  import ApiServices from '@/services/api.service'
  import SnackBar from '@/components/widgets/snackBar.vue'
  import Auth from '@/services/auth.service.js'
  import EditDialog from '@/components/settingspage/dialogs/ApiDialog'
  import axios from 'axios'
  
  export default {
    components: {
      SnackBar,
      EditDialog
    },
    data: () => ({
      snackbar: false,
      snackbarColorBt: "success",
      snacbarText: "",
      lineNumber: "",
      editDialog: false,
      progressShow: false,
      search: "",
      api: [{}],
      apiToEdit: {},
      overlay: false,
      headers: [
        { text: '#', value: "index", sortable: false, align: 'center', width: '50px' },
        { text: 'שם הפעולה', value: 'action_name', align: 'center' },
        { text: 'סטטוס', value: 'mode', align: 'center', width: '100px' },
        { text: 'Webhook', value: 'url', align: 'center', width: '100px' },
        { text: 'קבלת פרמטרים', value: 'response_params', align: 'center' },
        { text: 'פעולות', value: 'actions', sortable: false, align: 'center', width: '80px' },
      ],
    }),
    methods: {
      async getApiIntegrations() {
        try {
          this.progressShow = true;
          let token = localStorage.getItem("token");
          let api = process.env.VUE_APP_BASE_URL + `/settings/get_api_integrations`;
          const res = await fetch(api, ApiServices.requestOptions("GET", "", token));
          const jsonObject = await res.json();
          
          if (res.status >= 400) {
            this.showSnackBar("שגיאה בקבלת נתונים", "error");
          } else if (res.status === 200) {
            this.api = jsonObject.webhooksTemplates;
          }
        } catch (error) {
          this.showSnackBar("Error get api's: " + error, "error");
        } finally {
          this.progressShow = false;
        }
      },
      
      refreshDetails() {
        this.getApiIntegrations();
      },
      
      showSnackBar(message, color) {
        this.snacbarText = message;
        this.snackbarColorBt = color === "error" ? "red" : "green";
        this.snackbar = true;
      },
      
      openEditDialog(item, index) {
        const apiToEdit = this.api.find(api => api._id === item._id);
        this.apiToEdit = JSON.parse(JSON.stringify(apiToEdit)); // Create a deep copy
        this.editDialog = true;
      },
      
      editedApiSaved(item, text, color) {
        this.showSnackBar(text, color === "error" ? "red" : "green");
        
        if (item === "") {
          return;
        }
        
        // Find the index of the item in the api array
        const index = this.api.findIndex(api => api._id === item._id);
        
        if (index !== -1) {
          // Create a new object with the updated properties
          // This is important for reactivity in Vue
          this.api = [
            ...this.api.slice(0, index),
            { ...this.api[index], ...item },
            ...this.api.slice(index + 1)
          ];
        }
      }
    },
    computed: {
      dataFormated() {
        return this.api.map((item, index) => ({
          ...item,
          index: index + 1,
          action_name: item.action_name || 'לא מוגדר',
          params: item.params,
          _id: item._id,
          mode: item.mode === true ? 'פעיל' : 'מושבת',
          url: item.url ? 'קיים' : 'ריק',
          response_params: item.response_params || 'לא מוגדר',
        }));
      }
    },
    mounted() {
      this.lineNumber = Auth.getLineNumber();
      this.getApiIntegrations();
    },
  }
  </script>
  
  <style scoped>
  .api-integrations-container {
    font-family: 'Heebo', sans-serif;
  }
  
  .settings-card {
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s ease;
  }
  
  .settings-card:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
  }
  
  .primary-header {
    background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%);
    color: white;
    font-size: 1.5rem;
    font-weight: 600;
    padding: 16px;
  }
  
  .search-field {
    max-width: 300px;
  }
  
  .refresh-button {
    background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%);
    color: white;
    font-weight: 500;
    border-radius: 4px;
    transition: all 0.3s ease;
  }
  
  .refresh-button:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transform: translateY(-2px);
  }
  
  .api-table {
    border-radius: 8px;
    overflow: hidden;
  }
  
  .table-header-text {
    font-weight: 600;
    color: #0d2c6d;
    font-size: 0.95rem;
  }
  
  .status-chip, .url-chip {
    min-width: 70px;
    justify-content: center;
  }
  
  /* Responsive adjustments */
  @media (max-width: 960px) {
    .api-integrations-container {
      padding: 16px;
    }
    
    .primary-header {
      font-size: 1.25rem;
    }
    
    .search-field {
      max-width: 100%;
      margin-bottom: 16px;
    }
  }
  
  @media (max-width: 600px) {
    .d-flex.flex-wrap {
      flex-direction: column;
      align-items: stretch;
    }
    
    .refresh-button {
      margin-top: 8px;
      width: 100%;
    }
  }
  </style>